import * as Sentry from '@sentry/browser';

export default function registerErrorHandler() {
  if (!process.env.REACT_APP_SENTRY_DNS) {
    return;
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    environment: process.env.NODE_ENV
  });
}
